import { css } from 'styled-components';
import { BREAKPOINTS, MARGINS } from '../themes';
import { cssByBreakpoint } from './breakpoints';
import { pxToRem } from '../themes/BaseBreakpoints';
export var maxWidthContainer = function maxWidthContainer() {
  var maxBreakpointPx = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : BREAKPOINTS.XL;
  var marginSmall = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : MARGINS.MD;
  var marginMedium = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : MARGINS.XL;
  var marginLarge = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : MARGINS.XXL;
  return cssByBreakpoint([css(["margin:0 auto;width:calc(100% - ", "px);"], marginSmall * 2), css(["width:calc(100% - ", "px);"], marginMedium * 2), css(["width:calc(", " - ", "px);;"], pxToRem(maxBreakpointPx), marginLarge * 2)]);
};